import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/bq-store/category",
        component: List,
        name: "bq.category",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/category/create",
        component: Create,
        name: "bq.category.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/inventory/group/:id/edit",
        component: Edit,
        name: "bq.category.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
